/* istanbul ignore file */

// declarative file
export enum FormType {
  CONTACT = 'contact',
  FRAUD = 'fraud',
  REACTIVATION = 'reactivation',
  SECURITY = 'security',
  STANDARD = 'standard',
  TECHNICAL = 'technical',
}
